module.exports = __webpack_public_path__ + "img/icon-scan-failed-my.d69361e8.svg";